class FormatHelper {
  static getCurrency = (
    amount,
    fraction = 0,
    locale = "en-US",
    currency = "USD"
  ) => {
    return amount === null
      ? "N/A"
      : amount.toLocaleString(locale, {
          style: "currency",
          currency: currency,
          minimumFractionDigits: fraction,
        });
  };

  static getCountableTermValue(t, translationTerm, value, args) {
    return t(
      value === 1 ? `${translationTerm}.singular` : `${translationTerm}.plural`,
      args
    );
  }
}

export default FormatHelper;
